export default {
  h1_edu: "Обучающие курсы для врачей диагностов",
  Lessons: {
    Lesson: {
      title: "Урок",
      Files: "Приложения",
      DownloadAll: "Скачать все",
    },
    status: {
      success: "Пройден",
      unsuccess: "Не пройден",
      stop: "Недоступно",
    },
  },
  afterPayCourse: {
    title: "Вы успешно приобрели курс",
    text: "Теперь у вас есть доступ к обучающим материалам",
    buttonText: "Перейти к курсу",
  },
};
